<template>
    <li class="list-item">
        <div class="title">
            <featured-button
                :track-no="trackNo"
                :player-featured="player.featured"
                :show="show"
            />
            <div class="trackNo">
                {{
                    'serial' === show.podcastType ?
                    `${player.seasonNo} / ${player.episodeNo}` :
                     player.episodeNo
                }}
            </div>
            <a
                href="#"
                @click.prevent="$emit('edit-player', { trackNo: trackNo, trackGuid: player.guid })"
            >
                {{ player.title }}
            </a>
            <base-icon
                class="is-small edit-icon"
                icon="pencil-alt"
            />
        </div>
        <embed-button
            player-type="singleTrack"
            :track-no="trackNo"
            :track-guid="player.guid"
            @click="value => $emit('open-embed', value)"
        />
    </li>
</template>

<script>
import EmbedButton from './EmbedButton';
import FeaturedButton from '@/components/FeaturedButton';

export default {
    components: {
        EmbedButton,
        FeaturedButton,
    },

    props: {
        player: {
            type: Object,
            required: true,
        },
        show: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * Return track number.
         *
         * @returns {string} Track number.
         */
        trackNo() {
            if ('serial' === this.show.podcastType) {
                return `${this.player.seasonNo}:${this.player.episodeNo}`;
            }

            return this.player.episodeNo.toString();
        },
    },
};
</script>
